import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import showToast from '@/utils/toasts';
import { responseError } from '@/utils/errors';
import ErrorToast from '@/components/toasts/ErrorToast';
import actions from '../constants';

export function* downloadDictionariesErrorToast(action) {
  const error = responseError(action).message;
  yield call(showToast, <ErrorToast operation="actions.download" name={action.code} error={error} />);
}

export default function* dictionaryToasts() {
  yield takeEvery(actions.DOWNLOAD_DICTIONARIES_ERROR, downloadDictionariesErrorToast);
}
